export class PaginatedGetResult<T> {
    items: T[];
    columnSortedBy: string;
    count: number;
    pageSize: number;
    numberOfPages: number;
    totalItems: number;
  }
